import { useState, useEffect, useCallback } from 'react';
import { SubscriptionLimits, fetchSubscriptionLimits, isAtAthleteLimit } from '../services/subscriptionLimitsService';

interface UseSubscriptionLimitsReturn {
  limits: SubscriptionLimits | null;
  loading: boolean;
  error: Error | null;
  refetch: () => Promise<void>;
  canAddAthlete: boolean;
}

export function useSubscriptionLimits(): UseSubscriptionLimitsReturn {
  const [limits, setLimits] = useState<SubscriptionLimits | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchLimits = useCallback(async () => {
    try {
      setLoading(true);
      const data = await fetchSubscriptionLimits();
      setLimits(data);
      setError(null);
    } catch (err) {
      setError(err as Error);
      setLimits(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchLimits();
  }, [fetchLimits]);

  // Cannot add if current count >= max athletes (unlimited plans always can).
  // If limits is null, we cannot verify so return false (fail safe)
  const canAddAthlete = limits ? !isAtAthleteLimit(limits) : false;

  return {
    limits,
    loading,
    error,
    refetch: fetchLimits,
    canAddAthlete
  };
}

